import Vue from 'vue';
import Lang from 'laravel-vue-lang';

Vue.use(Lang, {
  locale: 'de',
  fallback: 'en',
});
